<template>
  <span
    ref="breadcrumbDropdownPopperTrigger"
    class="relative whitespace-nowrap flex items-center"
    @mouseenter="isDesktop && breadcrumbDropdownPopper.show()"
    @mouseleave="isDesktop && breadcrumbDropdownPopper.hide()"
  >
    <span class="hover:text-o-blue">
      <OLink :href="item.href" class="text-md" :class="{ 'font-semibold': lastItem }">
        {{ item.name }}
      </OLink>
      <OButton v-if="item.dropdown && item.dropdown.length" class="text-md ml-2 sm:inline hidden" pure>
        <OIcon icon="caret-down" />
      </OButton>
    </span>
    <OPopper
      v-if="isDesktop && item.dropdown && item.dropdown.length"
      ref="breadcrumbDropdownPopperView"
      :is-visible="breadcrumbDropdownPopper.visible"
      class="bg-white w-auto p-2 rounded-md z-2 shadow right-auto"
    >
      <OLink
        v-for="dropdownItem in item.dropdown"
        :key="dropdownItem.name"
        class="block p-2 text-sm font-medium text-[#7F8083] whitespace-nowrap"
        :href="dropdownItem.href"
      >
        {{ dropdownItem.name }}
      </OLink>
    </OPopper>
    <OIcon v-if="!lastItem" icon="chevron-right-grey" class="mr-4 ml-4 w-[7px] h-3" />
  </span>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton, OPopper, OLink, OIcon } from '~/modules/common/components/ui';
import { usePopper } from '~/composables/usePopper';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  props: {
    item: {
      type: Object,
    },
    lastItem: {
      type: Boolean,
      default: false,
    },
  },
  components: { OPopper, OButton, OLink, OIcon },
  setup() {
    const { isDesktop } = useDevice();
    const [breadcrumbDropdownPopperTrigger, breadcrumbDropdownPopperView, breadcrumbDropdownPopper] = usePopper({
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'computeStyles',
          options: {
            adaptive: false, // true by default
          },
        },
      ],
    });
    return { breadcrumbDropdownPopperTrigger, breadcrumbDropdownPopperView, breadcrumbDropdownPopper, isDesktop };
  },
});
</script>
